<template>
  <div class="home">
    <home-header></home-header>
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import HomeHeader from "@/components/HomeHeader.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    HomeHeader,
  },
  setup() {},
});
</script>
